/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   Lifestyles bizo
 */

import { Bizo, autoclass } from './base'
import type {
  HoodLifestyles as HoodLifestylesType,
  RawHoodLifestyles,
} from './hoodLifestyles.types'

export const HoodLifestyles: typeof HoodLifestylesType = autoclass<
  HoodLifestylesType,
  RawHoodLifestyles
>('HoodLifestyles', class HoodLifestyles extends Bizo<HoodLifestylesType, RawHoodLifestyles> {}, {
  hood: 'hood',
  hoodLifestyles: 'lifestyles',
})

export type HoodLifestyles = HoodLifestylesType
